
import React from "react";
import OwlCarousel from "react-owl-carousel";
// import { Col } from "reactstrap";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTranslation, withTranslation } from "react-i18next";
import banner1EN from "../../../assets/images/em-banner1-en.png";
import banner2EN from "../../../assets/images/em-banner2-en.png";
import banner1AR from "../../../assets/images/em-banner1-ar.png";
import banner2AR from "../../../assets/images/em-banner2-ar.png";
// import competitionBannerEN from "../../../assets/images/competition-banner-en.png";
// import competitionBannerAR from "../../../assets/images/competition-banner-ar.png";

const Slider = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n?.language;
  const isArabic = currentLang === "ar";
  const slides = [
    // { 
    //   en: competitionBannerEN, 
    //   ar: competitionBannerAR    
    // }, 
    { 
      en: banner1EN, 
      ar: banner1AR   
    }, 
    {
      en : banner2EN, 
      ar : banner2AR  
    }
  ];
  return (
    <div className='slider mb-3 h-auto'>
      <div className='slider__container p-4'>
        <OwlCarousel
          style={{ direction: "ltr" }}
          className="owl-theme"
          loop
          items={1}
          margin={0}
        >
          {slides.map((slide, idx) => (
            <div
              key={idx}
              className="slider__item"
              style={{
                margin: 0,
                padding: 0,
                borderRadius: 25,
              }}
            >
              <img
                src={slide?.[isArabic ? "ar" : "en"]}
                alt=""
                className="home_banner"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "fill",
                  display: "block",
                  cursor: "pointer",
                }}
              />
            </div>
          ))}
        </OwlCarousel>

      </div>
    </div>
  );
};
export default withTranslation()(Slider); 